"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "path-1",
    x: "6",
    y: "1",
    width: "2",
    height: "15"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "path-2",
    x: "12",
    y: "1",
    width: "2",
    height: "15"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Audiences",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    opacity: "0.900000036"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Customers",
    transform: "translate(-876.000000, -86.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "geofence",
    transform: "translate(868.000000, 79.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-6",
    transform: "translate(8.000000, 7.000000)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-12",
    stroke: props.fill,
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "18",
    height: "14",
    rx: "1"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: props.fill,
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6",
    y: "1",
    width: "2",
    height: "15"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: props.fill,
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12",
    y: "1",
    width: "2",
    height: "15"
  })))))));
};

exports["default"] = _default;